import { io, Socket } from "socket.io-client";

// Define interfaces for our system data
interface SystemStats {
  networkStatus: string;
  activeSessions: number;
  uptime: string;
}

interface ActivityUpdate {
  type: string;
  message: string;
  timestamp: Date;
}

class SocketService {
  private socket: Socket | null = null;
  private listeners: Map<string, Set<Function>> = new Map();
  
  // Connect to the WebSocket server
  connect(): void {
    if (this.socket) return;
    
    // TODO: Replace with your actual API URL from environment variables
    const SOCKET_URL = process.env.REACT_APP_BASE_URL || "http://10.50.227.120:3000";
      this.socket = io(SOCKET_URL, {
      transports: ['websocket'],
      autoConnect: true,
    });
    
    this.socket.on("connect", () => {
      console.log("Socket connected");
      // Request initial stats when connecting
      if (this.socket) {
        this.socket.emit("requestStats");
      }
    });
    
    this.socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });
    
    // Register default event handlers
    this.registerEventHandler("systemStats");
    this.registerEventHandler("activityUpdate");
  }
    // Clean up the socket connection
  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
  
  // Add a listener for a specific event
  addListener<T>(event: string, callback: (data: T) => void): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
      this.registerEventHandler(event);
    }
    
    const listeners = this.listeners.get(event)!;
    listeners.add(callback);
    
    // Return a function to remove this listener
    return () => {
      listeners.delete(callback);
    };
  }
    // Helper method to register socket event handlers
  private registerEventHandler(event: string): void {
    if (!this.socket) return;
    
    this.socket.on(event, (data) => {
      const listeners = this.listeners.get(event);
      if (listeners) {
        listeners.forEach(callback => callback(data));
      }
    });
  }
  
  // Check if socket is connected
  isConnected(): boolean {
    return this.socket?.connected || false;
  }
}

// Create a singleton instance
export const socketService = new SocketService();

export default socketService;
